import $ from 'jquery';
import slugify from 'slugify';
import { colSizes } from '../loader-utils';
import {
  createNewProjectType,
  projectClickHandler,
} from '../loader-event-handlers';
import { getState } from '~src/state';
import { requestNewProject } from '~src/userRequest';
import { checkFeaturePreference, isFeatureEnabled } from '../../features';

/**
 * Aggiunge i blocchi necessari per scegliere che tipo di progetto si vuole creare
 */
export const templateAddProjects = async (force = false) => {
  const { projects } = window.editorLoader;
  const selectedProjectType = getState('selected.tipo');

  const htmlProjects = await projects.items.reduce(
    async (accP, project) => {
      const acc = await accP;
      const projectFeatPref = await checkFeaturePreference(
        `project.${slugify(project.name.toLowerCase())}`
      );
      const isProjectEnabled = projectFeatPref.user && projectFeatPref.org;

      if (!isProjectEnabled && projectFeatPref.style === 'hidden') {
        return acc;
      }

      const elementId = `project-${project.objectId}`;
      const projectSlug = slugify(project.name.toLowerCase());
      const isSelected = selectedProjectType
        ? selectedProjectType.objectId === project.objectId
        : false;

      if (force === false) {
        if ($(`#${elementId}`).length > 0) {
          const wasSelected = $(`#${elementId}`).data('selected');
          if (!wasSelected && isSelected) {
            $(`#${elementId}`).data('selected', true);
            $(`#${elementId}`).addClass('block-selected');
          } else if (!wasSelected && !isSelected) {
            $(`#${elementId}`).data('selected', false);
            $(`#${elementId}`).removeClass('block-selected');
          }
        }
      } else {
        $('#editor-projects').empty();
      }

      let projectThumbnail;

      if (project.isGlobal) {
        if (project.animated) {
          projectThumbnail = `./assets/blocks/project-types/progetto-${slugify(
            project.name.toLowerCase()
          )}.gif`;
        } else {
          projectThumbnail = project.thumbnail?.url
            ? project.thumbnail.url
            : `./assets/blocks/project-types/progetto-${slugify(
                project.name.toLowerCase()
              )}.png`;
        }
      } else {
        projectThumbnail = project.thumbnail?.url
          ? project.thumbnail.url
          : './assets/blocks/placeholders/project-type.png';
      }

      const projectHtmlBlock = `
          <div 
            id="${elementId}" data-project-id="${project.objectId}"
            data-project-slug="${projectSlug}"
            ${
              isProjectEnabled
                ? 'data-project-enabled="true"'
                : 'data-project-enabled="false"'
            }
            class="${colSizes['regular']} mt-4 block-with-image ${
        isSelected && isProjectEnabled ? 'block-selected' : ''
      } ${projectFeatPref.style ? projectFeatPref.style : ''}">
            <div class="block-image lazy" data-bg="${projectThumbnail}"></div>
            <div class="block-name text-center">${project.name}</div>
          </div>`;

      acc.html = acc.html + projectHtmlBlock;
      acc.ids.push(`#${elementId}`);

      return acc;
    },
    { html: '', ids: [] }
  );

  let newProjectTitle;
  const projectThumbnail = './assets/blocks/new.png';

  $('body').off('click', '#new-project');

  if ((await isFeatureEnabled('projects.create')) && projects.allowNew) {
    newProjectTitle = 'Crea nuovo progetto';
    $('body').on('click', '#new-project', createNewProjectType);
  } else {
    newProjectTitle = 'Richiedi Progetto Personalizzato';
    $('body').on('click', '#new-project', requestNewProject);
  }

  const newProjectHtmlBlock = `
        <div
          id="new-project"
          class="${colSizes['regular']} mt-4 block-with-image editor-block-new-item">
          <div class="block-image bg-color-projects lazy" data-bg="${projectThumbnail}"></div>
          <div class="block-name text-center">${newProjectTitle}</div>
        </div>`;

  htmlProjects.html = htmlProjects.html + newProjectHtmlBlock;

  if (htmlProjects.html) {
    $('#editor-projects').html(htmlProjects.html);
  }

  window.lazyLoadInstance.update();

  if (htmlProjects.ids.length) {
    $('body').off('click', htmlProjects.ids.join(','));
    $('body').on('click', htmlProjects.ids.join(','), projectClickHandler);
    // enableTooltips();
  }
};
